import React from 'react';
import fr from 'facet-rest';
import { pickImplementation } from 'Helpers/Affordances';
import useUserContext from 'Context/UserContext';
import ScheduleSendDatePicker from './ScheduleSendDatePicker';

export default function ScheduleSendDatePickerPicker({ ...rest }) {
  const { agentResource } = useUserContext();

  return pickImplementation(agentResource, {
    [fr.relationships.default.name]: (
      <ScheduleSendDatePicker {...rest} />
    ),
  });
}
